import { render, staticRenderFns } from "./FooterRetailZone.vue?vue&type=template&id=2629c063&scoped=true"
import script from "./FooterRetailZone.vue?vue&type=script&lang=js"
export * from "./FooterRetailZone.vue?vue&type=script&lang=js"
import style0 from "./FooterRetailZone.vue?vue&type=style&index=0&id=2629c063&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2629c063",
  null
  
)

export default component.exports